<!-- Dialog: Auto Hedge Status Change  -->
<p-dialog
  #dialog
  [(visible)]="data.dialogData.show"
  [width]="data.dialogData.width"
  [resizable]="false"
  [closable]="true"
  [modal]="true"
  [draggableDialog]="dialog"
  styleClass="bfx-dialog-warning"
  (onHide)="closeDialog()"
>
  <p-header> {{ data.dialogData.title_text }} </p-header>

  <p>Are you sure you wish to turn Auto Hedging {{data.dialogData.targetStateString}}</p>
  <div class="autoHedge__body__status-change-comment">
    <p class="autoHedge__body__status-change-comment__content-details">
      Reasons For Turning Auto Hedging {{data.dialogData.targetStateString}}
    </p>

    <textarea
      pInputTextarea
      class="autoHedge__body__status-change-comment"
      [(ngModel)]="data.dialogData.comment"
      maxlength="250"
      rows="4"
      cols="62"
      autoResize="false"
      placeholder="{{data.dialogData.placeholder}}"
    ></textarea>
    <bfx-comment-warning></bfx-comment-warning>
  </div>
  <p-footer>
    <span fxFlex fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="4px">
      <button
        pButton
        type="button"
        class="bfx-button-secondary-subtle"
        (click)="actionNo()"
        label="No"
      ></button>
      <button
        pButton
        type="button"
        class="bfx-button-primary"
        (click)="actionYes()"
        label="Yes"
      ></button>
    </span>
  </p-footer>
</p-dialog>
